{
  "updatedOn": "Last updated: {{date}}",
  "nav": {
    "notice": "Legal notice",
    "privacy": "Privacy",
    "terms": "Terms of use"
  },
  "notice": {
    "title": "Legal notice",
    "updated": "2026-09-03",
    "pending": "This page is incomplete: the publisher's legal name, address, registration number, the name of the publication director and the host's details must be filled in by the operator before opening to the public. This information is not in the code and cannot be inferred from it.",
    "sections": [
      {
        "heading": "Publisher",
        "paragraphs": [
          "[Legal name] — [legal form] with a share capital of [amount].",
          "Registered office: [full postal address].",
          "Registration: [company register / number]. VAT number: [number].",
          "Publication director: [name and role].",
          "Contact: [contact email address]."
        ]
      },
      {
        "heading": "Hosting",
        "paragraphs": [
          "[Host name] — [postal address] — [phone].",
          "Data is hosted within the European Union."
        ]
      },
      {
        "heading": "Intellectual property",
        "paragraphs": [
          "Courses, lessons, exercises and resources published on the platform remain the property of their authors. The platform acquires no ownership of this content; it hosts it and serves it to enrolled users.",
          "The platform's trademarks, logos and interface elements are protected and may not be reproduced without the publisher's written permission."
        ]
      },
      {
        "heading": "Reporting content",
        "paragraphs": [
          "Any content can be reported from the interface. Reports are reviewed by the moderation team, which may dismiss the report, warn the author, hide the content or suspend the account concerned."
        ]
      }
    ]
  },
  "privacy": {
    "title": "Privacy policy",
    "updated": "2026-09-03",
    "pending": "The identity of the data controller, the data protection officer's details where applicable, and the register of processors must be completed by the operator. This document faithfully describes what the system does with your data; it must nevertheless be reviewed by a legal professional before opening to the public, particularly where minors are concerned.",
    "sections": [
      {
        "heading": "What we collect",
        "paragraphs": [
          "When the account is created: email address, first and last name. These are the only mandatory fields.",
          "Optionally, if you provide them: a headline, a biography, the subjects and languages you teach or learn, a time zone and a display language.",
          "From your use of the service: your course enrolments, your progress, your submissions and their marks, your messages, the files you upload, and your sign-in dates.",
          "Technically: your IP address and session identifier are written to the security log so that abuse can be detected."
        ]
      },
      {
        "heading": "Why",
        "paragraphs": [
          "To provide the service: keep your account, serve the courses you are enrolled in, compute your progress, pass your submissions to your teacher, issue your certificates.",
          "To keep the service safe: detect unusual sign-ins, token reuse and abuse, and keep a record of administrative actions.",
          "To inform you: in-app and email notifications, which you tune in your preferences. Strictly transactional notices — address verification, password change, moderation warning, certificate delivery — cannot be turned off."
        ]
      },
      {
        "heading": "Sharing your progress",
        "paragraphs": [
          "Your teacher can see your progress in their courses if you consent. That consent is explicit, can be withdrawn at any time from your preferences, and every change is timestamped in the log.",
          "Your contact details are never passed between platform modules: a teacher sees a display name, not an email address."
        ]
      },
      {
        "heading": "How long",
        "paragraphs": [
          "Technical logs: 90 days. Audit log: 3 years. Messages: 3 years. Accounts inactive for 3 years: anonymised.",
          "Read notifications are purged after 90 days."
        ]
      },
      {
        "heading": "Your rights",
        "paragraphs": [
          "Access and portability: from your account you can export, at any time, a structured archive containing your account, profile, preferences, roles, sessions and the dated history of your consents.",
          "Erasure: from your account as well. Deletion is scheduled 30 days out — that delay is a right to change your mind, during which the account stays usable and the request can be cancelled. After it, your identifying data is replaced: your name becomes “Deleted user” and your address a technical one.",
          "Both of these require you to enter your password again: they are the two actions a stolen session would make irreversible.",
          "Rectification: your profile and preferences can be changed at any time from your account."
        ]
      },
      {
        "heading": "What erasure does not remove",
        "paragraphs": [
          "Aggregated data — a course's enrolment count, usage statistics — is kept: once anonymised it no longer concerns you.",
          "Certificates already issued remain valid and verifiable, but no longer name anyone: the name they carry is read afresh each time they are printed, and becomes anonymous with the account.",
          "The audit log is not modified. It holds only technical identifiers, which anonymisation makes impossible to tie back to a person, and it is the only surviving proof that erasure was requested."
        ]
      },
      {
        "heading": "Minors",
        "paragraphs": [
          "Consent from a holder of parental authority is required under the age of 15."
        ]
      },
      {
        "heading": "Processors and location",
        "paragraphs": [
          "Hosting, email delivery and file storage are provided by suppliers whose list is kept up to date by the publisher: [register of processors].",
          "All data is hosted within the European Union."
        ]
      },
      {
        "heading": "Contacting us",
        "paragraphs": ["For any question about your data: [data controller's email address]."]
      }
    ]
  },
  "terms": {
    "title": "Terms of use",
    "updated": "2026-09-03",
    "pending": "The governing law, competent jurisdiction, detailed pricing terms and liability clauses must be completed and reviewed by a legal professional before opening to the public.",
    "sections": [
      {
        "heading": "Purpose",
        "paragraphs": [
          "These terms govern access to and use of the platform. Creating an account constitutes acceptance."
        ]
      },
      {
        "heading": "Your account",
        "paragraphs": [
          "An account is personal. You are responsible for keeping your password confidential and for actions taken from your sessions, which you can review and close at any time from your account.",
          "Your email address must be verified before you can publish, submit work or send a message. Reading remains open before verification."
        ]
      },
      {
        "heading": "Content and conduct",
        "paragraphs": [
          "You keep ownership of what you publish and grant us the right to host it and serve it to those allowed to see it.",
          "The following are prohibited: unlawful content, publishing third parties' personal data, harassment, impersonation, and automated use intended to circumvent service limits.",
          "Any content can be reported. A moderator may then view the reported content and its immediate context, within 72 hours of the report and only within that window; every such viewing is recorded by name. They may dismiss the report, warn you, hide the content or suspend your account."
        ]
      },
      {
        "heading": "Courses, progress and certificates",
        "paragraphs": [
          "Access to lessons may be conditional on passing exercises, at the discretion of the teacher who built the course.",
          "A certificate is issued automatically upon full completion of a course, once only, if the teacher's plan provides for it. It carries a number anyone can verify publicly, without an account.",
          "A certificate may be withdrawn by the course's teacher, with a stated reason. It remains verifiable, and the verification page states that it was withdrawn."
        ]
      },
      {
        "heading": "Plans and subscriptions",
        "paragraphs": [
          "Some capabilities depend on the plan the teacher has subscribed to: how many courses can be published, how many students, how much storage, whether certificates are issued.",
          "Pricing, commitment period and cancellation terms are set out at subscription: [pricing terms]."
        ]
      },
      {
        "heading": "Availability",
        "paragraphs": [
          "The service is provided without a guarantee of uninterrupted availability. Some features may be temporarily closed for security or operational reasons; the interface says so explicitly when that happens."
        ]
      },
      {
        "heading": "Suspension and termination",
        "paragraphs": [
          "An account may be suspended for breach of these terms. Suspension is reasoned and recorded.",
          "You may delete your account at any time from your account area; the terms and delays are described in the privacy policy."
        ]
      },
      {
        "heading": "Governing law",
        "paragraphs": ["[Governing law] — [competent jurisdiction]."]
      }
    ]
  }
}
